import { render, staticRenderFns } from "./Doll.vue?vue&type=template&id=6675dc46&scoped=true&"
import script from "./Doll.vue?vue&type=script&lang=js&"
export * from "./Doll.vue?vue&type=script&lang=js&"
import style0 from "./Doll.vue?vue&type=style&index=0&id=6675dc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675dc46",
  null
  
)

export default component.exports